import { ChatFragment } from '@school_ify/schoolify-repository/src/shared/types';

import { ChatTypes } from './types';

const {
  ADD_ACTIVE_ROOM,
  ADD_MESSAGE,
  CLEAN_CHAT_ROOM,
  CLEAN_ACTIVE_CHAT,
  FREE_TO_CHOOSE_INITIAL,
  ADD_ALL_MESSAGES,
  SOCKET_UPDATE,
  POP_NEW_MESSAGES,
  DELETE_MESSAGE,
  UPDATE_MESSAGE,
  SET_RESPONDING_MESSAGE,
  CLEAR_RESPONDING_MESSAGE,
  SET_REPLYS,
  UPDATE_REPLYS,
  ADD_REPLY,
  ADD_LIKE,
  DELETE_LIKE,
} = ChatTypes;

interface ChatState {
  activeChat: ChatFragment;
  messages: {
    id?: string;
    body: string;
    user_id: string;
    chat_id?: string;
    created_at?: string;
    replys?: any[];
    likes?: any[];
  }[];
  unredMessages: number;
  initialChat: boolean;
  socket: number;
  respondingMessage: any;
  replys: any;
}

export const initialState: ChatState = {
  activeChat: null,
  messages: [],
  unredMessages: 0,
  initialChat: false,
  socket: 0,
  respondingMessage: '',
  replys: [],
};

// eslint-disable-next-line default-param-last
const chatReducer = (state = initialState, action: any): ChatState => {
  switch (action.type) {
    case ADD_ACTIVE_ROOM: {
      return {
        ...state,
        activeChat: action.payload,
      };
    }
    case FREE_TO_CHOOSE_INITIAL: {
      return {
        ...state,
        initialChat: action.payload,
      };
    }
    case ADD_ALL_MESSAGES: {
      return {
        ...state,
        messages: [...action.payload],
      };
    }
    case ADD_MESSAGE: {
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };
    }
    case POP_NEW_MESSAGES: {
      return {
        ...state,
        messages: [...action.payload, ...state.messages],
      };
    }
    case SOCKET_UPDATE: {
      return {
        ...state,
        socket: state.socket + 1,
      };
    }
    case CLEAN_CHAT_ROOM: {
      return {
        ...state,
        messages: [],
      };
    }
    case CLEAN_ACTIVE_CHAT: {
      return {
        ...state,
        activeChat: null,
        initialChat: false,
      };
    }
    case DELETE_MESSAGE: {
      return {
        ...state,
        messages: state.messages.filter((message: any) => message.id !== action.payload),
      };
    }
    case UPDATE_MESSAGE: {
      return {
        ...state,
        messages: state.messages.map((message: any) => {
          if (message.id === action.payload.id) {
            message.body = action.payload.body;
            return message;
          }
          return message;
        }),
      };
    }
    case SET_RESPONDING_MESSAGE: {
      return {
        ...state,
        respondingMessage: action.payload,
      };
    }
    case CLEAR_RESPONDING_MESSAGE: {
      return {
        ...state,
        respondingMessage: '',
      };
    }
    case SET_REPLYS: {
      const sortedAllReplies = action.payload.sort((a: any, b: any) => {
        if (a.created_at && b.created_at) {
          return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        }
        return a;
      });
      return {
        ...state,
        replys: sortedAllReplies,
      };
    }
    case UPDATE_REPLYS: {
      const unchangedReplies = state.replys.filter(el => el.id !== action.payload?.id);
      const changedReply = action.payload;
      const allReplies = [...unchangedReplies, changedReply];

      const sortedAllReplies = allReplies.sort((a: any, b: any) => {
        if (a.created_at && b.created_at) {
          return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        }
        return a;
      });
      return {
        ...state,
        replys: sortedAllReplies,
      };
    }
    case ADD_REPLY: {
      const updatedMessages = JSON.parse(JSON.stringify(state.messages));
      const respondingIndex = updatedMessages.findIndex(
        (message: any) => message.id === action.payload.responding.id
      );
      const responding = updatedMessages[respondingIndex];
      responding.replys = [...responding.replys, action.payload];

      return {
        ...state,
        messages: updatedMessages,
      };
    }
    case ADD_LIKE: {
      const updatedMessages = JSON.parse(JSON.stringify(state.messages));
      const likeIndex = updatedMessages.findIndex(
        (message: any) => message.id === action.payload.chat_message_id
      );
      const responding = updatedMessages[likeIndex];
      responding.likes = [...responding.likes, action.payload];

      return {
        ...state,
        messages: updatedMessages,
      };
    }
    case DELETE_LIKE: {
      const updatedMessages = JSON.parse(JSON.stringify(state.messages));
      const likeIndex = updatedMessages.findIndex(
        (message: any) => message.id === action.payload.chat_message_id
      );
      const responding = updatedMessages[likeIndex];
      const likeIndexInLikes = responding.likes.findIndex(
        (like: any) => like.id === action.payload.id
      );
      responding.likes.splice(likeIndexInLikes, 1);
      return {
        ...state,
        messages: updatedMessages,
      };
    }
    default: {
      return state;
    }
  }
};

export default chatReducer;
